import vue from "vue";
import vueRouter from "vue-router";
import LoginVue from "@/views/Login.vue";
import AccountBookListVue from "@/views/AccountBookList.vue"
import DashBoardVue from "@/views/DashBoard.vue"
import VoucherListVue from "@/views/VoucherList.vue"
import IntelligentVoucherVue from "@/views/IntelligentVoucher.vue"
import GeneralLedgerVue from "@/views/GeneralLedger.vue"
import SubsidiaryLedgerVue from "@/views/SubsidiaryLedger.vue"
import AssistingSubsidiaryLedgerVue from "@/views/AssistingSubsidiaryLedger.vue"
import BalanceVue from "@/views/Balance.vue"
import AssistingBalanceVue from "@/views/AssistingBalance.vue"
import AdjustingVue from "@/views/Adjusting.vue"
import ChargeVue from "@/views/Charge.vue"
import DebitNoteVue from "@/views/DebitNote.vue"
import IncomeStatementVue from "@/views/IncomeStatement.vue"
import QuarterlyIncomeStatementVue from "@/views/QuarterlyIncomeStatement.vue"
import BalanceSheetVue from "@/views/BalanceSheet.vue"
import BusinessActivityVue from "@/views/BusinessActivity.vue"
import QuaterlyBusinessActivityVue from "@/views/QuaterlyBusinessActivity.vue"
import CashFlowStatementVue from "@/views/CashFlowStatement.vue"
import QuarterlyCashFlowStatementVue from "@/views/QuarterlyCashFlowStatement.vue"
import ClosingVue from "@/views/Closing.vue"
import DeclarationVue from "@/views/Declaration.vue"
import AssistingAccountVue from "@/views/AssistingAccount.vue"
import FixedAssetVue from "@/views/FixedAsset.vue"
import SubjectVue from "@/views/Subject.vue"
import VATInvoiceVue from "@/views/VATInvoice.vue"
import JournalVue from "@/views/Journal.vue"
import AddOtherBillVue from "@/views/AddOtherBill.vue"
import PayrollVue from "@/views/Payroll.vue"
import VerifyVATInvoiceVue from "@/views/VerifyVATInvoice.vue"
import VerifyJournalVue from "@/views/VerifyJournal.vue"
import VerifyOthersVue from "@/views/VerifyOthers.vue"
import VerifyPayrollVue from "@/views/VerifyPayroll.vue"
import IntelligentVoucherListVue from "@/views/IntelligentVoucherList.vue"
import TaxEntryVue from "@/views/TaxEntry.vue"
import TaxListVue from "@/views/TaxList.vue"
import PerformanceVue from "@/views/Performance.vue"
import BusinessAnalysisVue from "@/views/BusinessAnalysis.vue"
import UserVue from "@/views/User.vue"
import IntegralVue from "@/views/Integral.vue"
import LogRecordVue from "@/views/LogRecord.vue"
import VoucherVue from "@/views/Voucher.vue";
import SystemToolVue from "@/views/SystemTool.vue";
import MultiSubsidiaryVue from "@/views/MultiSubsidiary.vue";
import EITQuarterVue from "@/views/EITQuarter.vue";
import ProductionOperationTaxVue from "@/views/ProductionOperationTax.vue";
import AnnualEITVue from "@/views/AnnualEIT.vue";
import AnnualEITA000000Vue from "@/views/AnnualEITList/AnnualEITA000000.vue";
import AnnualEITA100000Vue from "@/views/AnnualEITList/AnnualEITA100000.vue";
import AnnualEITA101010Vue from "@/views/AnnualEITList/AnnualEITA101010.vue";
import AnnualEITA102010Vue from "@/views/AnnualEITList/AnnualEITA102010.vue";
import AnnualEITA104000Vue from "@/views/AnnualEITList/AnnualEITA104000.vue";
import AnnualEITA105000Vue from "@/views/AnnualEITList/AnnualEITA105000.vue";
import AnnualEITA105050Vue from "@/views/AnnualEITList/AnnualEITA105050.vue";
import AnnualEITA105060Vue from "@/views/AnnualEITList/AnnualEITA105060.vue";
import AnnualEITA105080Vue from "@/views/AnnualEITList/AnnualEITA105080.vue";
import AnnualEITA106000Vue from "@/views/AnnualEITList/AnnualEITA106000.vue";
import AnnualEITA107040Vue from "@/views/AnnualEITList/AnnualEITA107040.vue";
import ImportLogsVue from "@/views/ImportLogs.vue";
import TaxDeclarationVue from "@/views/TaxDeclaration.vue";
import TaxTaskVue from "@/views/TaxTask.vue";
import StampTaxVue from "@/views/StampTax.vue";
import RubbishVue from "@/views/Rubbish.vue";
import IncomeDistributionVue from "@/views/IncomeDistribution.vue"
import InventoryOrderVue from "@/views/InventoryOrder.vue"
import InventorySubsidiaryVue from "@/views/InventorySubsidiary.vue"
import InventoryBalanceVue from "@/views/InventoryBalance.vue"
import InventoryAdjustingVue from "@/views/InventoryAdjusting.vue"
import DataCollectVue from "@/views/DataCollect.vue"
import DataImportVue from "@/views/DataImport.vue"
import VoucherGeneralVue from "@/views/VoucherGeneral.vue"
import InvoiceScanVue from "@/components/Invoice/InvoiceScan.vue"
import MultiVue from "@/views/Multi.vue";
import MessageCodeVue from "@/views/MessageCode.vue";
import PropertyTaxVue from "@/views/PropertyTax.vue";
import LandUseTaxVue from "@/views/LandUseTax.vue";
import GsnbVue from "@/views/Gsnb.vue";
import BusinessVue from "@/views/Business.vue";


vue.use(vueRouter);

export const routes = [
	{
		path: "/",
		name: "AccountBookList",
		component: AccountBookListVue,
		meta: {
			name: "客户列表",
			icon: "记账"
		}
	},
	{
		path: "/accountbooklist",
		name: "AccountBookList",
		component: AccountBookListVue,
		meta: {
			name: "客户列表",
			icon: "记账"
		}
	},
	{
		path: "/login",
		name: "Login",
		component: LoginVue,
		meta: {
			name: "登录",
		},
	},
	{
		path: "/dashboard",
		name: "DashBoard",
		component: DashBoardVue,
		meta: {
			name: "进度监测",
			icon: "记账"
		}
	},
	{
		path: "/voucherlist",
		name: "VoucherList",
		component: VoucherListVue,
		meta: {
			name: "凭证列表",
		}
	},
	{
		path: "/intelligentvoucher",
		name: "IntelligentVoucher",
		component: IntelligentVoucherVue,
		meta: {
			name: "票据",
		},
	},
	{
		path: "/generalledger",
		name: "generalledger",
		component: GeneralLedgerVue,
		meta: {
			name: "总账",
		},
	},
	{
		path: "/subsidiaryledger",
		name: "subsidiaryledger",
		component: SubsidiaryLedgerVue,
		meta: {
			name: "明细账",
		},
	},
	{
		path: "/assistingsubsidiaryledger",
		name: "assistingsubsidiaryledger",
		component: AssistingSubsidiaryLedgerVue,
		meta: {
			name: "辅助明细账",
		},
	},
	{
		path: "/balance",
		name: "balance",
		component: BalanceVue,
		meta: {
			name: "余额表",
		},
	},
	{
		path: "/assistingbalance",
		name: "assistingbalance",
		component: AssistingBalanceVue,
		meta: {
			name: "辅助余额表",
		},
	},
	{
		path: "/adjusting",
		name: "adjusting",
		component: AdjustingVue,
		meta: {
			name: "结转",
		},
	},
	{
		path: "/charge",
		name: "charge",
		component: ChargeVue,
		meta: {
			name: "收费",
			icon: "收费"
		}
	},
	{
		path: "/debitNote",
		name: "debitNote",
		component: DebitNoteVue,
		meta: {
			name: "收费对账",
			icon: "收费"
		}
	},
	{
		path: "/incomestatement",
		name: "Incomestatement",
		component: IncomeStatementVue,
		meta: {
			name: "利润表",
		},
	},
	{
		path: "/incomeQuarterly",
		name: "incomeQuarterly",
		component: QuarterlyIncomeStatementVue,
		meta: {
			name: "利润季报表",
		},
	},
	{
		path: "/balanceSheet",
		name: "balanceSheet",
		component: BalanceSheetVue,
		meta: {
			name: "资产负债表",
		},
	},
	{
		path: "/businessActivity",
		name: "businessActivity",
		component: BusinessActivityVue,
		meta: {
			name: "业务活动表",
		},
	},
	{
		path: "/quaterlyActivity",
		name: "quaterlyActivity",
		component: QuaterlyBusinessActivityVue,
		meta: {
			name: "季度业务活动表",
		},
	},
	{
		path: "/cashFlowstatement",
		name: "cashFlowstatement",
		component: CashFlowStatementVue,
		meta: {
			name: "现金流量表",
		},
	},
	{
		path: "/QuarterlyCashFlowStatement",
		name: "QuarterlyCashFlowStatement",
		component: QuarterlyCashFlowStatementVue,
		meta: {
			name: "季度现金流量表",
		},
	},
	{
		path: "/closing",
		name: "closing",
		component: ClosingVue,
		meta: {
			name: "结账",
		},
	},
	{
		path: "/declaration",
		name: "declaration",
		component: DeclarationVue,
		meta: {
			name: "纳税申报表",
		},
	},
	{
		path: "/assistingaccount",
		name: "assistingaccount",
		component: AssistingAccountVue,
		meta: {
			name: "辅助核算",
		},
	},
	{
		path: "/fixedasset",
		name: "fixedasset",
		component: FixedAssetVue,
		meta: {
			name: "资产",
		},
	},
	{
		path: "/subject",
		name: "subject",
		component: SubjectVue,
		meta: {
			name: "科目",
		},
	},
	{
		path: "/invoice",
		name: "invoice",
		component: VATInvoiceVue,
		meta: {
			name: "增值税票",
		},
	},
	{
		path: "/journal",
		name: "Journal",
		component: JournalVue,
		meta: {
			name: "日记账",
		},
	},
	{
		path: "/addOtherBill",
		name: "addOtherBill",
		component: AddOtherBillVue,
		meta: {
			name: "其他票据",
		},
	},
	{
		path: "/payroll",
		name: "payroll",
		component: PayrollVue,
		meta: {
			name: "工资表",
		},
	},
	{
		path: "/verifyVATInvoicer",
		name: "verifyVATInvoice",
		component: VerifyVATInvoiceVue,
		meta: {
			name: "审核发票",
		},
	},
	{
		path: "/verifyJournal",
		name: "verifyJournal",
		component: VerifyJournalVue,
		meta: {
			name: "审核日记账",
		},
	},
	{
		path: "/verifyOthers",
		name: "verifyOthers",
		component: VerifyOthersVue,
		meta: {
			name: "审核其他票",
		},
	},
	{
		path: "/verifyPayroll",
		name: "verifyPayroll",
		component: VerifyPayrollVue,
		meta: {
			name: "审核工资表",
		},
	},
	{
		path: "/intelligentVoucherList",
		name: "intelligentVoucherList",
		component: IntelligentVoucherListVue,
		meta: {
			name: "票据生成的凭证列表",
		},
	},
	{
		path: "/taxentry",
		name: "taxentry",
		component: TaxEntryVue,
		meta: {
			name: "报税录入",
			icon: "报税"
		}
	},
	{
		path: "/taxlist",
		name: "taxList",
		component: TaxListVue,
		meta: {
			name: "报税列表",
			icon: "报税"
		}
	},
	{
		path: "/performance",
		name: "performance",
		component: PerformanceVue,
		meta: {
			name: "员工绩效",
			icon: "管理"
		}
	},
	{
		path: "/managementanalysis",
		name: "managementanalysis",
		component: BusinessAnalysisVue,
		meta: {
			name: "经营分析",
			icon: "管理"
		}
	},
	{
		path: "/user",
		name: "user",
		component: UserVue,
		meta: {
			name: "人员组织",
			icon: "管理"
		}
	},
	{
		path: "/integral",
		name: "integral",
		component: IntegralVue,
		meta: {
			name: "我的积分",
			icon: "管理"
		}
	},
	{
		path: "/logrecord",
		name: "logrecord",
		component: LogRecordVue,
		meta: {
			name: "系统日志",
			icon: "管理"
		}
	},
	{
		path: "/voucher",
		name: "voucher",
		component: VoucherVue,
		meta: {
			name: "新增凭证",
		}
	},
	{
		path: "/systemtool",
		name: "systemtool",
		component: SystemToolVue,
		meta: {
			name: "systemtool",
			icon: "管理"
		}
	},
	{
		path: "/multiSubsidiary",
		name: "multiSubsidiary",
		component: MultiSubsidiaryVue,
		meta: {
			name: "多栏账",
		},
	},
	{
		path: "/EITQuarter",
		name: "EITQuarter",
		component: EITQuarterVue,
		meta: {
			name: "企业所得税(季度)",
		},
	},
	{
		path: "/ProductionOperationTax",
		name: "ProductionOperationTax",
		component: ProductionOperationTaxVue,
		meta: {
			name: "生产经营所得税申报表",
		},
	},
	{
		path: "/AnnualEIT",
		name: "AnnualEIT",
		component: AnnualEITVue,
		meta: {
			name: "企业所得税(年度)",
		},
	},
	{
		path: "/AnnualEITA000000",
		name: "AnnualEITA000000",
		component: AnnualEITA000000Vue,
		meta: {
			name: "企业基础信息表",
		},
	},
	{
		path: "/AnnualEITA100000",
		name: "AnnualEITA100000",
		component: AnnualEITA100000Vue,
		meta: {
			name: "企业所得税年度纳税申报表（A类）",
		},
	},
	{
		path: "/AnnualEITA101010",
		name: "AnnualEITA101010",
		component: AnnualEITA101010Vue,
		meta: {
			name: "一般企业收入明细表",
		},
	},
	{
		path: "/AnnualEITA102010",
		name: "AnnualEITA102010",
		component: AnnualEITA102010Vue,
		meta: {
			name: "一般企业成本支出明细表",
		},
	},
	{
		path: "/AnnualEITA104000",
		name: "AnnualEITA104000",
		component: AnnualEITA104000Vue,
		meta: {
			name: "期间费用明细表",
		},
	},
	{
		path: "/AnnualEITA105000",
		name: "AnnualEITA105000",
		component: AnnualEITA105000Vue,
		meta: {
			name: "纳税调整项目明细表",
		},
	},
	{
		path: "/AnnualEITA105050",
		name: "AnnualEITA105050",
		component: AnnualEITA105050Vue,
		meta: {
			name: "职工薪酬支出及纳税调整明细表",
		},
	},
	{
		path: "/AnnualEITA105060",
		name: "AnnualEITA105060",
		component: AnnualEITA105060Vue,
		meta: {
			name: "广告费和业务宣传费跨年度纳税调整明细表",
		},
	},
	{
		path: "/AnnualEITA105080",
		name: "AnnualEITA105080",
		component: AnnualEITA105080Vue,
		meta: {
			name: "资产折旧、摊销及纳税调整明细表",
		},
	},
	{
		path: "/AnnualEITA106000",
		name: "AnnualEITA106000",
		component: AnnualEITA106000Vue,
		meta: {
			name: "企业所得税弥补亏损明细表",
		},
	},
	{
		path: "/AnnualEITA107040",
		name: "AnnualEITA107040",
		component: AnnualEITA107040Vue,
		meta: {
			name: "减免所得税优惠明细表",
		},
	},
	{
		path: "/StampTax",
		name: "StampTax",
		component: StampTaxVue,
		meta: {
			name: "印花税",
		},
	},
	{
		path: "/Rubbish",
		name: "Rubbish",
		component: RubbishVue,
		meta: {
			name: "城镇垃圾费",
		},
	},
	{
		path: "/importLogs",
		name: "ImportLogs",
		component: ImportLogsVue,
		meta: {
			name: "导入日志",
			icon: "管理"
		}
	},
	{
		path: "/taxdeclaration",
		name: "taxdeclaration",
		component: TaxDeclarationVue,
		meta: {
			name: "一键报税",
			icon: "报税"
		}
	},
	{
		path: "/taxtask",
		name: "taxtask",
		component: TaxTaskVue,
		meta: {
			icon: "报税"
		}
	},
	{
		path: "/incomeDistribution",
		name: "incomeDistribution",
		component: IncomeDistributionVue,
		meta: {
			name: "收益及收益分配表",
		},
	},
	// InventoryOrder
	{
		path: "/inventoryOrder",
		name: "InventoryOrder",
		component: InventoryOrderVue,
		meta: {
			name: "出入库单据",
		},
	},
	// InventorySubsidiaryVue,
	{
		path: "/inventorySubsidiary",
		name: "InventorySubsidiary",
		component: InventorySubsidiaryVue,
		meta: {
			name: "库存明细表",
		},
	},
	// InventoryBalanceVue,
	{
		path: "/inventoryBalance",
		name: "InventoryBalance",
		component: InventoryBalanceVue,
		meta: {
			name: "库存余额表",
		},
	},
	{
		path: "/inventoryAdjusting",
		name: "InventoryAdjusting",
		component: InventoryAdjustingVue,
		meta: {
			name: "产成品结转",
		},
	},
	{
		path: "/datacollect",
		name: "DataCollect",
		component: DataCollectVue,
		meta: {
			name: "账套迁移",
			icon: "账套迁移"
		}
	},
	{
		path: "/dataimport",
		name: "DataImport",
		component: DataImportVue,
		meta: {
			name: "数据导入",
			icon: "账套迁移"
		}
	},
	{
		path: "/vouchergeneral",
		name: "vouchergeneral",
		component: VoucherGeneralVue,
		meta: {
			name: "凭证汇总表",
		},
	},
	{
		path: "/invoicescan",
		name: "InvoiceScan",
		component: InvoiceScanVue,
		meta: {
			name: "发票扫描",
		},
	},
	{
		path: "/multi",
		name: "Multi",
		component: MultiVue,
		meta: {
			name: "批量操作",
			icon: "记账"
		},
	},
	{
		path: "/messagecode",
		name: "MessageCode",
		component: MessageCodeVue,
		meta: {
			name: "短信列表",
			icon: "管理"
		}
	},
	{
		path: "/propertyTax",
		name: "propertyTax",
		component: PropertyTaxVue,
		meta: {
			name: "房产税",
		},
	},
	{
		path: "/landUseTax",
		name: "landUseTax",
		component: LandUseTaxVue,
		meta: {
			name: "城镇土地使用税",
		},
	},
	// GsnbVue
	{
		path: "/gsnb",
		name: "gsnb",
		component: GsnbVue,
		meta: {
			name: "记账"
		}
	},
	{
		path: "/business",
		name: "business",
		component: BusinessVue,
		meta: {
			icon: "工商"
		}
	},
];

const router = new vueRouter({
	routes: routes,
	mode: "history"
});

export default router;
